import { render, staticRenderFns } from "./registrant-py.vue?vue&type=template&id=83ff3c5a&scoped=true"
import script from "./registrant-py.vue?vue&type=script&lang=js"
export * from "./registrant-py.vue?vue&type=script&lang=js"
import style0 from "./registrant-py.vue?vue&type=style&index=0&id=83ff3c5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ff3c5a",
  null
  
)

export default component.exports